import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import {
  MultiCheckboxContainer,
  SelectAllNoneContainer,
  SelectStatusCheckboxes,
  CheckboxContentWrapper,
  LabelWrapper,
  CheckboxesContainer,
  DisplaySecondaryLabel,
} from "./styles";

import { FormGroup } from "react-bootstrap";
import styled from "styled-components";

const isChecked = ({ value, ticker }: { value: string; ticker: string }) => {
  return (value && value.indexOf(ticker) >= 0) || value === ticker;
};

export const FormGroupStyled = styled(({ multiCheckboxType, disabled, ...rest }: any) => (
  <FormGroup {...rest} />
))`
  ${props => (props.disabled ? `pointer-events: none;` : ``)}
  .checkbox label {
    ${props =>
      props.multiCheckboxType === "LIST"
        ? "display: block !important"
        : "display: inline-block !important"};
  }
`;

export const InputMultiCheckbox = ({
  defaultValues,
  onChange,
  name,
  value,
  field,
  relatedEntities,
  locale,
  className,
  horizontal,
  getDisplay,
  ...rest
}: any) => {
  useEffect(() => {
    if (defaultValues) onChange([...defaultValues]);
  }, [defaultValues, onChange]);

  const handleOnChange = ({ event, ticker }: any) => {
    const val = value || [];
    const newVal = event.target.checked ? [...val, ticker] : val.filter((it: any) => it !== ticker);
    onChange([...newVal]);
  };

  const setTrueAllCheckboxes = () => {
    const { options, entity } = field;
    const checkBoxList = (relatedEntities && relatedEntities[entity]) || options || [];
    onChange([...checkBoxList.map((value: any) => value.ticker)]);
  };

  const setFalseAllCheckboxes = () => onChange([]);

  const {
    description,
    options,
    disabled,
    selectables,
    entity,
    entityDisplay,
    mapping,
    multiCheckboxType,
  } = field;

  const checkBoxList = (relatedEntities && relatedEntities[entity]) || options || [];

  return (
    <div className={`${className} multicheckboxGroup`}>
      <FormGroupStyled multiCheckboxType={multiCheckboxType} disabled={disabled}>
        <div className="multicheckbox checkbox c-checkbox needsclick">
          <div>
            {description}
            <MultiCheckboxContainer className={"multicheckboxes-container"}>
              {selectables && (
                <SelectAllNoneContainer>
                  <SelectStatusCheckboxes onClick={setTrueAllCheckboxes}>
                    <FormattedMessage {...messages.selectAll} />
                  </SelectStatusCheckboxes>
                  &nbsp;/&nbsp;
                  <SelectStatusCheckboxes onClick={setFalseAllCheckboxes}>
                    <FormattedMessage {...messages.deselectAll} />
                  </SelectStatusCheckboxes>
                </SelectAllNoneContainer>
              )}
              {checkBoxList.map((option: any, index: number) => {
                let displayLabel =
                  (mapping && mapping[locale] && mapping[locale][option[entityDisplay]]) ||
                  option[entityDisplay] ||
                  (getDisplay && getDisplay(option)) ||
                  option.name;

                return (
                  /**TODO: Change key index to be unique */
                  <CheckboxContentWrapper>
                    <LabelWrapper>
                      <label key={index} className="needsclick">
                        <CheckboxesContainer>
                          <input
                            name={name}
                            disabled={disabled}
                            type="checkbox"
                            className="needsclick-input"
                            checked={isChecked({
                              value: value || defaultValues,
                              ticker: option.ticker,
                            })}
                            onChange={event =>
                              handleOnChange({
                                event,
                                ticker: option.ticker,
                              })
                            }
                            {...rest}
                          />
                          <em className="fa fa-check" />
                          {displayLabel}
                        </CheckboxesContainer>
                      </label>
                    </LabelWrapper>
                  </CheckboxContentWrapper>
                );
              })}
            </MultiCheckboxContainer>
          </div>
        </div>
      </FormGroupStyled>
    </div>
  );
};
